<div class="min-h-screen w-full flex flex-col bg-white" >
  
  <div class="relative w-full">
    <!-- Background Image -->
    <img 
      [src]="tenant.getImg(tenant.GIVEAWAYS)" 
      alt="Hero Background"
      class="w-full h-[420px] object-cover">

    <!-- Text Content -->
    <div class="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-4">
      <h1 class="md:text-6xl text-5xl text-white font-extrabold mb-2">This giveaway has ended</h1>
      <p class="md:text-3xl  font-semibold mt-4">
        We're sorry, but this giveaway is now closed for new entries.
      </p>
		<p class="md:text-3xl  font-semibold mt-4">
			Please check back for other giveaway opportunities.
		</p>
    </div>
  </div>

	<div class="text-white py-6 px-4" [style.backgroundColor]="loadeddata?.PrimaryColor">
		<h2 class="text-center font-semibold mb-6 text-white">PREMIUM GIVEAWAYS INCLUDES:</h2>

		<div class="grid grid-cols-4 md:grid-cols-4 gap-6 text-center md:max-w-[50%] mx-auto">
			<div *ngFor="let item of iconsWithLabels">
				<img [src]="item.icon" [alt]="item.label" class="mx-auto h-10 mb-2">
				<p class="text-xs md:text-sm">{{ item.label }}</p>
			</div>
		</div>
	</div>
  
</div>